module.exports = "/_next/static/images/getchat-logo-fd99f32bfdded5f1dc6ae203f4a37322.png";